export default __webpack_public_path__ + "static/media/committee-hoefler.47d93dcc.png";